<template>
    <div id="edit-canvas-page">
        <div class="top-buttons">
            <ui5-button
                @click="saveCanvas"
                :disabled="loading || saving"
            >
                <spinner v-if="saving" />
                {{ trans('pages.edit_canvas.save') }}
            </ui5-button>
            <ui5-button @click="cancel">
                {{ trans('pages.edit_canvas.cancel') }}
            </ui5-button>
        </div>

        <pre
            class="debug"
            v-if="isDebug"
            >{{ { canvas } }}</pre
        >

        <spinner-text v-if="loading">
            {{ trans('pages.edit_canvas.loading') }}
        </spinner-text>
        <template v-else>
            <div>
                <div class="field">
                    <ui5-label for="code">
                        {{ trans('pages.edit_canvas.canvas_number') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="code"
                        id="code"
                        @input="canvas.code = $event.target.value"
                        :value="canvas.code"
                    />
                </div>
                <div class="field">
                    <ui5-label for="type">
                        {{ trans('pages.edit_canvas.canvas_type') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="type"
                        id="type"
                        @input="canvas.type = $event.target.value"
                        :value="canvas.type"
                    />
                </div>
                <div class="field">
                    <ui5-label for="color">
                        {{ trans('pages.edit_canvas.color') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="color"
                        id="color"
                        @input="canvas.color = $event.target.value"
                        :value="canvas.color"
                    />
                </div>
                <div class="field">
                    <ui5-label for="code_manufacturer">
                        {{ trans('pages.edit_canvas.manufacturer_code') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="codeManufacturer"
                        id="code_manufacturer"
                        @input="canvas.codeManufacturer = $event.target.value"
                        :value="canvas.codeManufacturer"
                    />
                </div>
                <div class="field">
                    <ui5-label for="manufacturer">
                        {{ trans('pages.edit_canvas.manufacturer') }}
                    </ui5-label>
                    <ui5-input
                        type="Text"
                        name="manufacturer"
                        id="manufacturer"
                        @input="canvas.manufacturer = $event.target.value"
                        :value="canvas.manufacturer"
                    />
                </div>
                <div class="field">
                    <ui5-label for="description">
                        {{ trans('pages.edit_canvas.description') }}
                    </ui5-label>
                    <ui5-textarea
                        name="description"
                        id="description"
                        @input="canvas.description = $event.target.value"
                        :value="canvas.description"
                    />
                </div>
                <div class="field">
                    <ui5-label for="notes">
                        {{ trans('pages.edit_canvas.notes') }}
                    </ui5-label>
                    <ui5-textarea
                        name="notes"
                        id="notes"
                        @input="canvas.notes = $event.target.value"
                        :value="canvas.notes"
                    />
                </div>
                <div class="field">
                    <ui5-label for="default_canvas">
                        {{ trans('pages.edit_canvas.default_canvas') }}
                    </ui5-label>
                    <ui5-switch
                        :text-on="trans('pages.edit_canvas.yes')"
                        :text-off="trans('pages.edit_canvas.no')"
                        id="default_canvas"
                        :checked="canvas.defaultCanvas"
                        @change="canvas.defaultCanvas = $event.target.checked"
                    />
                </div>
                <div class="field">
                    <ui5-label for="sort">
                        {{ trans('pages.edit_canvas.sort') }}
                    </ui5-label>
                    <text-input
                        type="number"
                        name="sort"
                        id="sort"
                        v-model="canvas.sort"
                    />
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import canvasApi from '../api/canvas';
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput.vue';

export default {
    components: { Spinner, SpinnerText, TextInput },
    data() {
        return {
            loading: false,
            saving: false,
            canvas: {},
        };
    },
    mixins: [IsDebugMixin, IdParamMixin(), localization],
    methods: {
        load() {
            if (this.idParam) {
                this.populateEditCanvasPage();
            }
        },
        cancel() {
            if (this.idParam) {
                this.$router.push('/canvaspage/' + this.idParam);
            } else {
                this.$router.push('/canvasoverview');
            }
        },
        populateEditCanvasPage() {
            const canvasId = this.idParam;
            this.loading = true;
            Promise.all([
                canvasApi.fetch(canvasId).then((response) => {
                    const canvas = response.data;

                    this.$store.commit(
                        'general/setPageTitle',
                        'Doek ' +
                            canvas.code +
                            (canvas.description
                                ? ' - ' + canvas.description
                                : null),
                        { root: true }
                    );

                    this.canvas = canvas;
                }),
            ]).then(() => {
                this.loading = false;
            });
        },
        saveCanvas() {
            const canvasId = this.idParam;
            var name = this.canvas.name;

            if (name == '') {
                return showErrorMessage(
                    this.trans('pages.edit_canvas.errors.required_fields')
                );
            }

            this.saving = true;
            var {
                id: _,
                updated: _,
                flowId: _,
                articleId: _,
                ...payload
            } = this.canvas;
            if (canvasId != null) {
                payload.canvasId = canvasId;
            }

            canvasApi
                .update(payload, canvasId)
                .then(() => {
                    if (canvasId != null) {
                        this.$router.push('/canvaspage/' + canvasId);
                    } else {
                        this.$router.push('/canvasoverview');
                    }
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.edit_canvas.errors.save_failed')
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
